"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NoWirelessAccountState = /** @class */ (function () {
    function NoWirelessAccountState() {
    }
    return NoWirelessAccountState;
}());
exports.default = NoWirelessAccountState;
//# sourceMappingURL=NoWirelessAccountState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/NoWirelessAccount/NoWirelessAccountState.js
// module id = 1655
// module chunks = 8